import { ListItemIcon, MenuItem } from "@material-ui/core";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import { get } from "lodash";
import React, { Fragment, useState } from "react";
import {
	Button,
	Confirm,
	useCreate,
	useGetOne,
	useNotify,
	useTranslate,
} from "react-admin";

const GenerateUserPaymentButton = ({
	record,
	isButton = false,
	basePath,
	...props
}) => {
	const id = get(record, "id");
	const name = get(record, "name");
	const translate = useTranslate();
	const notify = useNotify();
	const [open, setOpen] = useState(false);
	const handleClick = () => setOpen(true);
	const handleDialogClose = () => setOpen(false);
	const { data: lastRange, loading: loadingLastRange } = useGetOne(
		"user-payments",
		"last-range"
	);
	const year = get(lastRange, "year", 0);
	const month = get(lastRange, "month", 0);
	const command = {
		name: "payments",
		args: ["generate", year, month, id],
		notify_args: {
			title: translate("users.actions.generate_user_payment.notify_title", {
				name,
			}),
			content: translate("users.actions.generate_user_payment.notify_content"),
			resource: "user-payments",
		},
	};
	const [create, { loading }] = useCreate("commands", command, {
		onSuccess: () => {
			notify("users.actions.generate_user_payment.success");
		},
	});
	const handleConfirm = () => {
		create();
		setOpen(false);
	};
	const label = translate("users.actions.generate_user_payment", {
		period: `${year}/${month}`,
	});

	return (
		<Fragment>
			{isButton ? (
				<Button
					disabled={loading || loadingLastRange}
					color="secondary"
					label={label}
					onClick={handleClick}
					disableElevation
					{...props}
				>
					<AccountBalanceWalletIcon />
				</Button>
			) : (
				<MenuItem onClick={handleClick}>
					<ListItemIcon>
						<AccountBalanceWalletIcon size="small" />
					</ListItemIcon>
					{label}
				</MenuItem>
			)}
			<Confirm
				isOpen={open}
				loading={loading}
				title={translate("users.actions.generate_user_payment.title")}
				content={translate("users.actions.generate_user_payment.content")}
				onConfirm={handleConfirm}
				onClose={handleDialogClose}
			/>
		</Fragment>
	);
};

export default GenerateUserPaymentButton;
